import { createEntityAdapter } from '@reduxjs/toolkit';
import { AdFortmatParams } from './adformats.types';

const adapter = createEntityAdapter<AdFortmatParams>();

export default adapter;
